import { createNativeStackNavigator } from "@react-navigation/native-stack";

export type LoginNavigationParamList = {
  Login: {
    organization?: string;
    invitation?: string;
    organization_name?: string;
    display_name?: string;
    email_hint?: string;
  };
  GroupDeviceLogin: undefined;
  SupportAccessEntry: {
    code: string;
  };
};

export const LoginStackNavigator =
  createNativeStackNavigator<LoginNavigationParamList>();
